import { render, staticRenderFns } from "./PurchaseAddPopup.vue?vue&type=template&id=70bb0b3a&"
import script from "./PurchaseAddPopup.vue?vue&type=script&lang=js&"
export * from "./PurchaseAddPopup.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAddPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports